module.exports = __webpack_public_path__ + "static/media/user.46c989fe.png";